import { useCallback, useState } from 'react';

function readChoice(key, allowed, fallback) {
  try {
    const value = window.localStorage.getItem(key);
    return allowed.includes(value) ? value : fallback;
  } catch (error) {
    return fallback; // armazenamento bloqueado (ex.: aba anônima do Safari)
  }
}

// Escolha lembrada neste aparelho (localStorage). Valor desconhecido ou armazenamento bloqueado: fallback.
// allowed deve ser uma lista fixa (constante do módulo)
export function useStoredChoice(key, allowed, fallback) {
  const [value, setValue] = useState(() => readChoice(key, allowed, fallback));

  const update = useCallback((next) => {
    if (!allowed.includes(next)) return;
    setValue(next);
    try {
      window.localStorage.setItem(key, next);
    } catch (error) {
      // armazenamento bloqueado: a escolha vale só até recarregar a página
    }
  }, [key, allowed]);

  return [value, update];
}
